
import React from "react";
import useFormattedText from "helpers/useFormattedText";

function SponsoredTeaser({ gated, link, tag, eyebrow, title, body, media, containerClass, bundle }) {  
  /**
   * @param {MouseEvent} e 
   */
  const checkIfGated = (e) => {
    if (gated) {
      Drupal.behaviors?.kineticGatingModal?.handleGatedLinkClick(e);
    }
  }

  return (
    <a onClick={checkIfGated} href={link} target="_blank" title={`View ${title}`} className={`sponsored-teaser ${containerClass}`}>
      <div className="sponsored-teaser__above">
        {gated ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill="none">
            <path
              fill="#BCAEA1"
              d="M4.5 4.5V6h5V4.5a2.5 2.5 0 1 0-5 0ZM2.5 6V4.5a4.501 4.501 0 0 1 9 0V6h.5c1.103 0 2 .897 2 2v6c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h.5Z"/>
          </svg>
        ) : null}
        { tag && <span className="tag tag--card"> Sponsored </span> }
      </div>
      <div className="sponsored-teaser__content d-flex flex-column">
        <span className="eyebrow"> {eyebrow} </span>
        <h4 className="h3"> {title} </h4>
        { body && <div className="p-small sponsored-teaser__content-body" dangerouslySetInnerHTML={useFormattedText(body, 115)}/> }
        { media && (
          <div className="media">
            <img loading='lazy' src={media.urlPath} width='auto' height='155px' alt={media.alt} />
            <span className="icon-overlay"></span>
          </div>
        )}
      </div>
    </a>
  );
}

export default SponsoredTeaser;
